<template>
  <section class="about-us">
    <div class="container">
      <div class="heading">
        <h2 class="title-subhead text-center-xs">Was ist ELSAZEIT?</h2>
      </div>
      <div class="inner-hold">
        <div class="video-hold">
          <a href="#"><img
            src="@/../public/img/presentation/1.png"
            height="367"
            width="586"
            alt="image description"></a>
        </div>
        <div class="content">
          <div class="text">
            <p>Elsazeit wurde speziell für die gesetzliche Stundenaufzeichnung entwickelt. In Verbindung mit künstlicher Intelligenz ist es möglich, die Stunden der jeweiligen Mitarbeiter automatisch zu erstellen.</p>
            <p>Elsazeit wurde aus der Praxis, für die Praxis entwickelt. Durch Elsazeit <span class="text-bold">sparen Sie bis zu 95%</span> Ihrer Zeit und müssen sich nicht mit unötigem Papierkram beschäftigen. Elsazeit ist sehr einfach zu bedienen! Sie erhalten in kurzer Zeit Ihre Ergebnisse.</p>
            <p>Vermeiden Sie hohe Vertragsstrafen durch den Zoll oder einer Lohnsteuerprüfung.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeAboutUs'
}
</script>

<style scoped>

</style>
